import React, { useState, useEffect } from 'react';
// @material-ui/core components
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Pagination from '@material-ui/lab/Pagination';
import { Link } from 'react-router-dom';
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
// core components
import { connect } from 'react-redux';
import { getAllUsers, deleteDriver, addWalletAmount } from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';
import { Input } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
const PAGE_LIMIT = 2000
const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

const UsersTable = (props) => {
  const classes = useStyles();
  const [modal, setModal] = useState(false);
  const [walletModal, setWalletModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [walletMoney, setWalletMoney] = useState(null)
  const [page, setPage] = useState(1);

  const toggle = () => setModal(!modal);
  const toggleWallet = () => setWalletModal(!walletModal);
  const toggle2 = () => setModal2(!modal2);

  const [itemDelete, setItemDelete] = useState(0);
  const [itemId, setItemId] = useState(null);

  const handleWalletMoneyChange = (event) => {
    setWalletMoney(event.target.value)
  }

  useEffect(() => {
    props.getAllUsers(1);
  }, []);

  const handleDelete = (id) => {
    // props.deleteDriver(id).then((data) => {
    //   if (data) {
    //     props.getAllUsers(1);
    //   }
    // });
  };
  const handlePagination = (event, value) => {
    setPage(value);
    props.getAllUsers(value);
  };

  const handleWalletMoneyAdd = (id) => {
    props.addWalletAmount(id, walletMoney).then((data) => {
      if (data) {
        setWalletMoney(null)
        props.getAllUsers(1);
      }
    });
  }
  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>
          All Users
        </h4>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Phone</th>
            <th>Name</th>
            <th>Email</th>
            <th>Wallet Balance</th>
            <th>Add Wallet Balance</th>
            <th>Transactions</th>
            {/* <th>Update</th>
            <th>Delete</th> */}
          </tr>
        </thead>
        <tbody>
          {props.allUsers?.map((item, i) => (
            <tr key={item.id}>
              <th scope="row">{i + 1 + (page ? (page - 1) * PAGE_LIMIT : 0)}</th>
              <td>{item.phone_number}</td>
              <td>{item.firstName} {item.lastName}</td>
              <td>{item.emailId}</td>
              <td>{item.walletAmount}</td>
              <td>
                <AttachMoneyIcon
                  style={{ cursor: 'pointer' }}
                  onClick={function (event) {
                    toggleWallet();
                    setItemId(item.id);
                  }}
                />
              </td>
              <td>
                <VisibilityIcon
                  style={{ cursor: 'pointer' }}
                  onClick={function (event) {
                    props.history.push('/admin/user/transactions/' + item.id);
                  }}
                />
              </td>
              {/* <td>
                <Link
                  style={{ color: '#000' }}
                  to={'/admin/edit-user/' + item.id}
                >
                  <EditIcon />
                </Link>
              </td>
              <td>
                <DeleteIcon
                  style={{ cursor: 'pointer' }}
                  onClick={function (event) {
                    toggle();
                    setItemDelete(item.id);
                  }}
                />
              </td> */}
            </tr>
          ))}
        </tbody>
      </Table>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Delete</ModalHeader>
        <ModalBody>Do you really want to delete this Delivery Boy??</ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={walletModal} toggle={toggleWallet}>
        <ModalHeader toggle={toggleWallet}>Add Wallet Money</ModalHeader>
        <ModalBody>
          <Input type="number" value={walletMoney} onChange={handleWalletMoneyChange} placeholder="Amount" />
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            disabled={!walletMoney}
            onClick={function (event) {
              handleWalletMoneyAdd(itemId);
              toggleWallet();
            }}
          >
            Add
          </Button>{' '}
          <Button color="secondary" onClick={toggleWallet}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

const mapStateWithProps = (state) => ({
  allUsers: state.admin.allUsers,
  pageCount: state.admin.pageCount
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getAllUsers: (id) => dispatch(getAllUsers(id, PAGE_LIMIT)),
    deleteDriver: (vendorId) => dispatch(deleteDriver(vendorId)),
    addWalletAmount: (id, amount) => dispatch(addWalletAmount(id, amount)),
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(UsersTable);
